// Random slug instead of "/vendor" so the URL itself isn't guessable - see
// backend/app/api/v1/endpoints/vendor_auth.py, which mounts its router at
// the same slug. Keep these two in sync if the slug ever changes. Same
// obscurity pattern as ADMIN_BASE_PATH (adminApi.js) - not linked from any
// public page, reached only via a direct URL handed to vendors.
export const VENDOR_BASE_PATH = 'dd15b88347357ece';
export const VENDOR_TOKEN_KEY = 'zg_vendor_token';

export class VendorAuthError extends Error {}

// Same shape as adminFetch (see lib/adminApi.js): wraps fetch with the
// bearer token and a consistent base path, throwing VendorAuthError on a
// 401 (also clearing the stored token) so callers can redirect to login in
// one place instead of repeating that check after every request.
export async function vendorFetch(path, options = {}) {
  const token = sessionStorage.getItem(VENDOR_TOKEN_KEY);
  const res = await fetch(`/api/${VENDOR_BASE_PATH}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.status === 401) {
    sessionStorage.removeItem(VENDOR_TOKEN_KEY);
    throw new VendorAuthError('Not authenticated');
  }

  return res;
}
